export default "__VITE_ASSET__BzxROu9n__"